export default function Portfolio() {
  const testimonials = [
    {
      name: '田中 健太',
      title: '製造業・経営者',
      avatar: 'https://public.readdy.ai/ai/img_res/b11898a1ef1fc47bf4bf1927e666d153.jpg',
      content: '業務フローの棚卸しから始めていただき、どこにAIを導入すべきか明確になりました。木村さんの伴走支援のおかげで、社内でのAI定着がスムーズに進んでいます。'
    },
    {
      name: '佐藤 美咲',
      title: 'マーケティング担当',
      avatar: 'https://readdy.ai/api/search-image?query=professional-japanese-asian-female-business-woman-portrait-headshot-neutral-clean-background-friendly-warm-smile-business-attire-professional-makeup-well-lit-studio-photography&width=100&height=100&seq=avatar-jp-002&orientation=squarish',
      content: 'AIライティングの支援を受けて、コンテンツ制作のスピードが3倍になりました。人間らしさを保ちながら効率化できるのが素晴らしいです。'
    },
    {
      name: '山田 雄一',
      title: 'IT企業・事業部長',
      avatar: 'https://readdy.ai/api/search-image?query=professional-japanese-asian-male-business-manager-portrait-headshot-neutral-clean-background-serious-confident-expression-business-suit-glasses-well-lit-studio-photography&width=100&height=100&seq=avatar-jp-003&orientation=squarish',
      content: 'プロンプト設計の講座を受講しました。実務で即活用できる内容ばかりで、チーム全体のAI活用レベルが向上しました。'
    },
    {
      name: '鈴木 麻衣',
      title: 'コンサルタント',
      avatar: 'https://readdy.ai/api/search-image?query=professional-japanese-asian-female-consultant-portrait-headshot-neutral-clean-background-confident-intelligent-look-business-attire-professional-appearance-well-lit-studio-photography&width=100&height=100&seq=avatar-jp-004&orientation=squarish',
      content: 'SNSコンテンツの企画から実行まで、一貫してサポートしていただきました。発信が継続できるようになり、クライアント獲得につながっています。'
    },
    {
      name: '高橋 誠',
      title: '小売業・店舗責任者',
      avatar: 'https://readdy.ai/api/search-image?query=professional-japanese-asian-male-retail-manager-portrait-headshot-neutral-clean-background-approachable-friendly-smile-business-casual-attire-warm-expression-well-lit-studio-photography&width=100&height=100&seq=avatar-jp-005&orientation=squarish',
      content: 'チャットボットの構築支援を受けました。お客様対応の質が向上し、スタッフの負担も大幅に軽減されました。導入後のフォローも手厚く安心です。'
    },
    {
      name: '伊藤 真理子',
      title: 'ライター',
      avatar: 'https://readdy.ai/api/search-image?query=professional-japanese-asian-female-writer-portrait-headshot-neutral-clean-background-creative-thoughtful-expression-casual-professional-attire-artistic-appearance-well-lit-studio-photography&width=100&height=100&seq=avatar-jp-006&orientation=squarish',
      content: 'AIと人の感性を融合させる文章設計を学び、執筆の幅が広がりました。木村さんの丁寧な指導で、自信を持ってAIを活用できるようになりました。'
    }
  ];

  return (
    <section id="portfolio" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="mb-12 sm:mb-16 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 animate-fade-in-up">
          <div>
            <span className="inline-block bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold px-5 py-2 rounded-full mb-4">
              VOICE
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-purple-900 tracking-tight">
              お客様の声
            </h2>
          </div>
          
          <img 
            src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/e0a38c2585532f9a804a48c9264dc408.png" 
            alt="KIMURAMA WORKS" 
            className="h-6 sm:h-8 opacity-30"
          />
        </div>

        {/* オフィス風景画像を追加 */}
        <div className="mb-12 sm:mb-16 animate-fade-in-up" style={{ animationDelay: '100ms' }}>
          <div className="relative rounded-lg overflow-hidden shadow-xl">
            <img 
              src="https://readdy.ai/api/search-image?query=modern-bright-japanese-office-meeting-room-professional-asian-japanese-business-team-collaboration-consulting-session-multiple-people-working-with-laptop-computers-natural-daylight-through-windows-contemporary-corporate-atmosphere-diverse-professionals-teamwork-discussion&width=1400&height=500&seq=office-collaboration-jp-001&orientation=landscape" 
              alt="お客様との協働" 
              className="w-full h-48 sm:h-64 lg:h-80 object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-purple-900/70 to-transparent"></div>
            <div className="absolute bottom-6 sm:bottom-10 left-6 sm:left-10 right-6 sm:right-10">
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mb-2 sm:mb-3">
                お客様と共に成長する
              </h3>
              <p className="text-base sm:text-lg font-medium text-white/90 max-w-3xl">
                50社以上の企業様、300名以上の個人の方々にAI活用をサポートしてきました
              </p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white border border-purple-100 rounded-lg p-6 sm:p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in-up"
              style={{ animationDelay: `${(index + 2) * 100}ms` }}
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar} 
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div>
                  <p className="text-lg font-bold text-purple-900">
                    {testimonial.name}
                  </p>
                  <p className="text-base font-medium text-purple-700 mt-1">
                    {testimonial.title}
                  </p>
                </div>
              </div>
              
              <p className="text-base font-medium text-purple-800 leading-relaxed">
                「{testimonial.content}」
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}